import { push as pushRoute } from 'connected-react-router';

import {
    put, select, takeLatest,
} from 'redux-saga/effects';

import { extractQueryParameters, buildQueryParameters } from 'helpers/RoutesHelpers';
import Routes from '../constants/Routes';

import {
    getLocationSelector,
    getPathnameSelector,
} from '../../commons/selectors/RouterSelector';

import {
    OPEN_CMP_MODAL,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const location = yield select(getLocationSelector);
    const searchParameters = extractQueryParameters(location.search);
    const pathname = yield select(getPathnameSelector);
    const params = {
        ...searchParameters,
        'cmp-modal': Routes.COOKIES_LIST.link,
    };
    const queryParams = buildQueryParameters(params);
    yield put(pushRoute(`${pathname}?${queryParams}`));
}

export function* watch() {
    yield takeLatest(OPEN_CMP_MODAL, callAction);
}
